/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getProductsByManufacturerItemIdAsync } from './DataActionExtension.g';
import { ISearchTextProductMap } from './DataServiceEntities.g';

/**
 * B2bGetProducts Input Action
 */
export class B2bGetProductsInput implements Msdyn365.IActionInput {
    public itemId: string[];
    public manufacturerCode: string | undefined;
    constructor(itemId: string[], manufacturerCode?: string) {
        this.itemId = itemId;
        this.manufacturerCode = manufacturerCode;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ProductResults`;
    public getCacheObjectType = () => 'ProductResults';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IB2bGetProductsData {
    products: ISearchTextProductMap[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createGetProductsInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const itemId = args.requestContext.query?.itemId;
    const manufacturerCode = args.requestContext.query?.manufacturerCode;
    if (!itemId) {
        throw Error('Item Id missing');
    }
    return new B2bGetProductsInput([itemId], manufacturerCode);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProducts(input: B2bGetProductsInput, ctx: Msdyn365.IActionContext): Promise<IB2bGetProductsData> {
    const response = await getProductsByManufacturerItemIdAsync({ callerContext: ctx }, input.itemId, input.manufacturerCode || '');
    // const response = input.manufacturerCode
    //     ? await getProductsByManufacturerItemIdAsync({ callerContext: ctx }, input.itemId, input.manufacturerCode)
    //     : await getProductsByItemIdAsync({ callerContext: ctx }, input.itemId);
    return { products: response };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IB2bGetProductsData>>getProducts,
    // TODO: Give your data action a unique id
    id: 'B2bGetProducts',
    input: createGetProductsInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
